import { useCallback, useState } from 'react'
import { seedMessages } from '../data/portal'
import { getReply } from '../utils/chat'
import type { ChatMessage } from '../types/portal'

const newId = () => `${Date.now()}-${Math.random().toString(36).slice(2, 7)}`

export function useChat() {
  const [messages, setMessages] = useState<ChatMessage[]>(seedMessages)
  const [typing, setTyping] = useState(false)
  const [draft, setDraft] = useState('')

  const send = useCallback(
    (text: string) => {
      const value = text.trim()
      if (!value || typing) return
      setMessages((m) => [...m, { id: newId(), role: 'user', text: value }])
      setDraft('')
      setTyping(true)
      window.setTimeout(() => {
        const reply = getReply(value)
        setMessages((m) => [...m, { id: newId(), role: 'assistant', text: reply.text, source: reply.source }])
        setTyping(false)
      }, 750)
    },
    [typing],
  )

  return { messages, typing, draft, setDraft, send }
}
